<template>
<section style="display:flex;flex-direction:column;gap:20px;">
  <template v-if="checkItem.reportTypeId">
    <div>
      <label>选择测量器具</label>
      <div style="display:flex;flex-wrap:wrap;column-gap:10px;margin-top:5px;">
        <label
          v-for="measureInstrument in measureInstruments"
          :key="measureInstrument.id"
          style="display:flex;align-items:center;gap:3px;"
        >
          <input
            v-model="checkItem.inBlankOpts[0].taskMeasureInstrumentId"
            type="radio"
            :value="measureInstrument.id" style="margin:0;"
            @change="onCompleteChange"
          />
          {{measureInstrument.measureInstrumentName}}-{{measureInstrument.measureInstrumentNumber}}
        </label>
      </div>
    </div>
  </template>
  <component
    v-for="(opt, optIndex) in checkItem.inBlankOpts"
    :key="optIndex"
    :is="opt.formulaMode"
    :completion="opt"
    :measure-instruments="measureInstruments"
    :style="`margin-top:${optIndex > 0 ? '12px' : 0}`"
    @complete-change="onCompleteChange"
  />
</section>
</template>

<script>
import loader from '@/utils/loader'

import BaseTaskResultOptionComponent from '../BaseTaskResultOptionComponent'

const COMPONENT_MAP = loader.getByCustom(require.context('./Formula', true, /\.vue$/), (componentMap, component, path) => {
  let componentName = component.name

  componentMap[componentName] = {
    formula: componentName,
    componentName: componentName,
    getSelected: component.getSelected
  }
})

export default {
  name: 'TaskResultCompletion',
  extends: BaseTaskResultOptionComponent,
  OPTION_TYPE: 3,
  getSelected: checkItem => checkItem.inBlankOpts.map(opt => {
    let component = COMPONENT_MAP[opt.formulaMode]
    return component ? component.getSelected(opt) : ''
  }),
  methods: {
    onCompleteChange () {
      let checkItem = this.checkItem
      let opts = checkItem.inBlankOpts
      checkItem.isCompleted = checkItem.reportTypeId ? (checkItem.inBlankOpts[0].taskMeasureInstrumentId && (opts.find(({isCompleted}) => isCompleted !== true) === undefined)) : (opts.find(({isCompleted}) => isCompleted !== true) === undefined)
      checkItem.score = opts.reduce((count, opt) => count + (opt.isCompleted * opt.isQualified * opt.score), 0)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/index.vue